import * as React from 'react';
import cn from 'classnames';
import { widgetContext } from '../../context/widgetContext';
import * as styles from './styles.css';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var Label = function Label(props) {
  var _React$useContext = React.useContext(widgetContext),
      isDesktop = _React$useContext.isDesktop;

  return /*#__PURE__*/_jsxs("label", {
    children: [/*#__PURE__*/_jsx("span", {
      className: cn(styles['label'], isDesktop && styles['label-desktop'], props.className),
      children: props.label
    }), props.children]
  });
};
Label.displayName = 'Label';